import React from 'react';

export default class Page2 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">This tool can help</div>
                                            <p>This classic research neatly describes how creativity and
                                                innovation can be prompted by almost anything. This tool is
                                                about <span
                                                    className="green">how  to  be  innovative</span> and
                                                provides you with insight into where innovation and
                                                creativity come from and how they can be harnessed for
                                                yourself and encouraged in those around you.</p>
                                            <div className="circle_title"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>WHY FOCUS ON INNOVATION ?
                                            </div>
                                            <p>Everyone is capable of innovation and all jobs require it.
                                                Any job that does not require the ability to produce a
                                                unique output or solution is probably already being done by
                                                a machine or a computer. While it comes more easily to some
                                                than others – depending on personality, aptitude, motivation
                                                and training – we all have brains that are evolved for
                                                creative problem solving and innovation.</p>
                                            <p>So why don’t we get the chance – or indeed give ourselves the
                                                chance? A lot of the answer lies in the stereotypes we have
                                                of ourselves, of our employees or of specific job roles. If
                                                we see ourselves as operating primarily in the ‘task’ domain
                                                (i.e. we tend to focus on the importance of completing tasks
                                                quickly and effectively), we might simply not give ourselves
                                                time to step over into the ‘thought’ domain and flex our
                                                more innovative muscles.</p>
                                            <div className="border_subtitle">Definitions</div>
                                            <p>Innovation means the process of coming up with new ideas,
                                                processes, solutions or products. It means tackling a
                                                challenge in a way that has not been tried before. It does
                                                not necessarily mean invention. You can innovate by applying
                                                an existing solution in a novel way or by combining
                                                solutions to tackle a new problem. So, innovation means
                                                doing something different, but it doesn’t have to mean
                                                starting from scratch. Indeed, Benjamin Franklin suggested
                                                that a definition of insanity was ‘doing the same thing over
                                                and over again and expecting different results’! This is why
                                                everyday innovation is important. More than half the battle
                                                is to ask the question: ‘could we be doing this
                                                differently?’</p>
                                            <div className="border_subtitle">Climate and barriers</div>
                                            <p>The climate that we work in is a key determinant of how much
                                                of our capacity to innovate we bring to work with us. Do we
                                                work – or encourage others to work – in a ‘yes...but’
                                                environment where analysis overrides original thinking? Do
                                                we work – or encourage others to work – in an environment
                                                where controls and metrics mean that there is little
                                                opportunity and little encouragement to try out new things?
                                                Does our climate reward systemisation more than speculation?
                                                An unsupportive business environment will make it all the
                                                more likely that we will save our moments of innovation – be
                                                they a daily or a yearly event – for the weekend.</p>
                                            <div className="border_subtitle">Key questions to foster
                                                innovation
                                            </div>
                                            <p> A simple way to encourage innovation – your own or others –
                                                is to ask the right questions. In our own work we have
                                                developed five key questioning areas which encourage
                                                open-ended thinking about a situation or challenge. These
                                                always ensure multiple perspectives are considered in
                                                framing a solution or a new idea.</p>
                                            <p>These questioning areas are outlined in the model on the next
                                                page.</p>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page1')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}